import styled from 'styled-components';
import { getTrendColor } from '../utils/cardValueHelpers';

export const CardContainer = styled.div`
  background-color: ${props => (props.theme.colors && props.theme.colors.surface && props.theme.colors.surface.base) || '#ffffff'};
  border-radius: ${props => (props.theme.radii && props.theme.radii.lg) || '8px'};
  box-shadow: ${props => (props.theme.shadows && props.theme.shadows.sm) || '0 1px 2px 0 rgba(0, 0, 0, 0.05)'};
  padding: ${props => (props.theme.spacing && props.theme.spacing.lg) || '24px'};
  display: flex;
  flex-direction: column;
  border: 1px solid ${props => (props.theme.colors && props.theme.colors.border) || '#e5e7eb'};
  transition: box-shadow 0.2s ease-in-out;
  
  &:hover {
    box-shadow: ${props => (props.theme.shadows && props.theme.shadows.md) || '0 4px 6px -1px rgba(0, 0, 0, 0.1)'};
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${props => (props.theme.spacing && props.theme.spacing.sm) || '12px'};
`;

export const CardTitle = styled.h3`
  margin: 0;
  font-family: ${props => (props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif'};
  font-size: ${props => (props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.sm) || '14px'};
  font-weight: 500;
  color: ${props => (props.theme.colors && props.theme.colors.text && props.theme.colors.text.muted) || '#6b7280'};
`;

export const CardIconWrapper = styled.div`
  color: ${props => (props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.primary) || '#2563eb'};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${props => (props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.primary) || '#2563eb'}15;
`;

export const CardContent = styled.div`
  display: flex;
  align-items:baseline;
  gap: ${props => (props.theme.spacing && props.theme.spacing.sm) || '8px'};
`;

export const CardMainValue = styled.div`
  font-family: ${props => (props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif'};
  font-size: ${props => (props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.xxl) || '24px'};
  font-weight: 700;
  color: ${props => (props.theme.colors && props.theme.colors.text && props.theme.colors.text.primary) || '#111827'};
`;

export const CardTrend = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: ${props => (props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif'};
  font-size: ${props => (props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.xs) || '12px'};
  font-weight: 600;
  color: ${props => getTrendColor(props.trend, props.theme)};
`;



// WEBPACK FOOTER //
// ./src/design-system/molecules/CardValue/components/CardValueStyles.js